import { render, staticRenderFns } from "./InnovationDetailPage.vue?vue&type=template&id=2bfc19ae&"
import script from "./InnovationDetailPage.vue?vue&type=script&lang=js&"
export * from "./InnovationDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./InnovationDetailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports